
import { Component, Prop, Vue } from 'nuxt-property-decorator'
import ProviderCommonCard from '~/components/providers/ProviderCommonCard.vue'
import { ExtendedProviderModel } from '~/core/offer.types'

@Component({
  components: {
    ProviderCommonCard,
  },
})
export default class AboutProvider extends Vue {
  @Prop({ required: true, default: () => ({}), type: Object })
  private readonly provider!: ExtendedProviderModel

  @Prop({ required: true, default: () => ([]), type: Array })
  private readonly tableOfContents!: any[]

  get providerDescription () {
    // eslint-disable-next-line camelcase
    return this.provider.description || ''
  }

  getTOCItemUrl (href: string) {
    return `${this.$route.path}${href}`
  }

  onTOCItemClick (href: string) {
    const el = document.querySelector(href)

    if (!el) { return }

    this.$scrollTo(el, 200, {
      offset: -80,
    })
  }
}
